<template>
  <div class="com-album-card" v-if="is_loading || card_data.creator_heybox_id" @click="openAlbum">
    <div class="game-img-album" :class="`layout-${card_data?.game_images?.length > 4 ? 4 : card_data?.game_images?.length}`">
      <img class="game-img-item" :class="`game-img-${index}`" v-for="(img, index) in card_data.game_images" :key="index" v-hb-img.src="img" alt="" />
    </div>
    <div class="album-info">
      <div class="line-1">
        <div class="album-label"></div>
        <span class="album-name">{{ card_data.title }}</span>
      </div>
      <div class="line-2">
        <span class="game-num">{{ card_data.game_count }}款游戏</span>
        <div class="favour-btn" :class="{ favoured: is_favoured }" @click="onClickFavourBtn">
          <svg v-if="is_favoured" xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="rgba(140, 145, 150, 1)">
            <path
              d="M6.93813 1.82094C7.15049 1.33747 7.84967 1.33747 8.06204 1.82094L9.25885 4.5457C9.34743 4.74736 9.54131 4.88547 9.7643 4.90574L12.7772 5.17972C13.3119 5.22833 13.5279 5.88028 13.1246 6.22771L10.8513 8.18567C10.683 8.33058 10.609 8.55404 10.6582 8.76824L11.3235 11.6623C11.4416 12.1758 10.8759 12.5788 10.4142 12.31L7.81247 10.7953C7.6199 10.6832 7.38026 10.6832 7.1877 10.7953L4.58592 12.31C4.12426 12.5788 3.55861 12.1758 3.67666 11.6623L4.34195 8.76824C4.39118 8.55404 4.31713 8.33058 4.14888 8.18567L1.87561 6.22771C1.47224 5.88029 1.6883 5.22833 2.22291 5.17972L5.23586 4.90574C5.45886 4.88547 5.65273 4.74736 5.74131 4.5457L6.93813 1.82094Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.404 1.58635C6.82061 0.637884 8.17947 0.637881 8.59608 1.58635L9.7929 4.31111C9.79431 4.31432 9.80122 4.32336 9.81709 4.3248L12.83 4.59878C13.8581 4.69226 14.3137 5.97332 13.5052 6.66969L11.2319 8.62766C11.2285 8.63062 11.2273 8.6331 11.2269 8.63447C11.2266 8.63523 11.2265 8.63579 11.2265 8.63614C11.2265 8.63642 11.2265 8.63682 11.2267 8.63755L11.892 11.5316C12.1313 12.5729 10.9969 13.3242 10.1207 12.8141L7.51894 11.2995C7.51386 11.2965 7.50744 11.2946 7.50004 11.2946C7.49264 11.2946 7.48622 11.2965 7.48114 11.2995L4.87937 12.8141C4.00322 13.3242 2.86875 12.5729 3.10811 11.5316L3.7734 8.63755C3.77357 8.63682 3.77357 8.63642 3.77356 8.63614C3.77354 8.63592 3.77351 8.63563 3.77343 8.63526C3.77338 8.63503 3.77331 8.63476 3.77321 8.63447C3.77276 8.6331 3.77159 8.63062 3.76815 8.62766L1.49488 6.66969C0.686369 5.97332 1.14201 4.69226 2.17005 4.59878L5.183 4.3248C5.19887 4.32336 5.20577 4.31432 5.20719 4.31111L6.404 1.58635ZM7.4767 2.0475C7.47666 2.04755 7.47479 2.04957 7.47217 2.05553L6.27535 4.78029C6.09961 5.1804 5.71876 5.44757 5.28865 5.48668L2.2757 5.76065C2.26614 5.76152 2.26137 5.76329 2.25987 5.76391C2.25824 5.76458 2.25754 5.76511 2.25712 5.76546C2.25591 5.76645 2.25305 5.76957 2.2512 5.77516C2.25055 5.77712 2.25026 5.77865 2.25013 5.77971L2.25017 5.77976C2.25116 5.78092 2.25306 5.78296 2.25625 5.78571L4.52953 7.74368C4.85965 8.02801 5.00877 8.47103 4.91041 8.89892L4.24513 11.793C4.24474 11.7947 4.2445 11.796 4.24435 11.797C4.24565 11.7987 4.24809 11.8014 4.2523 11.8044C4.26024 11.8101 4.26799 11.8121 4.27256 11.8124C4.27451 11.8126 4.27628 11.8125 4.27836 11.812C4.28026 11.8115 4.28489 11.8102 4.29239 11.8059L6.89417 10.2912C7.26814 10.0735 7.73194 10.0735 8.10591 10.2912L10.7077 11.8059C10.7152 11.8102 10.7198 11.8115 10.7217 11.812C10.7238 11.8125 10.7256 11.8126 10.7275 11.8124C10.7321 11.8121 10.7398 11.8101 10.7478 11.8044C10.752 11.8014 10.7544 11.7987 10.7557 11.797C10.7556 11.796 10.7553 11.7947 10.755 11.793L10.0897 8.89892C9.99131 8.47103 10.1404 8.02801 10.4706 7.74368L12.7438 5.78571C12.747 5.78296 12.7489 5.78092 12.7499 5.77976L12.7499 5.77971C12.7498 5.77865 12.7495 5.77712 12.7489 5.77516C12.747 5.76957 12.7442 5.76645 12.743 5.76546C12.7428 5.7653 12.7425 5.7651 12.7422 5.76487C12.7417 5.7646 12.7411 5.76428 12.7402 5.76391C12.7387 5.76329 12.7339 5.76152 12.7244 5.76065L9.71144 5.48668C9.28132 5.44757 8.90047 5.1804 8.72473 4.78029L7.52791 2.05553C7.52534 2.04968 7.5235 2.04763 7.52339 2.04751L7.52338 2.0475L7.52337 2.04749C7.5232 2.0473 7.52297 2.04703 7.52211 2.04651C7.51973 2.04505 7.51213 2.04167 7.50004 2.04167C7.48796 2.04167 7.48035 2.04505 7.47797 2.04651C7.4771 2.04704 7.47688 2.0473 7.4767 2.0475ZM2.24893 5.77818C2.24896 5.77821 2.24897 5.77826 2.249 5.77832L2.24893 5.77818ZM2.24893 5.77818L2.24885 5.77806C2.24885 5.77806 2.24886 5.77808 2.24889 5.77811C2.2489 5.77813 2.24892 5.77815 2.24893 5.77818Z"
              fill="rgba(140, 145, 150, 1)"
            />
          </svg>
          <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.74722 1.81297C7.22334 0.72901 8.77633 0.729007 9.25245 1.81297L10.6202 4.92698C10.6219 4.93066 10.6298 4.94098 10.6479 4.94263L14.0913 5.25575C15.2661 5.36258 15.7869 6.82665 14.8629 7.62251L12.2649 9.86018C12.2609 9.86357 12.2596 9.8664 12.2591 9.86797C12.2588 9.86884 12.2587 9.86948 12.2587 9.86987C12.2587 9.8702 12.2587 9.87066 12.2589 9.87148L13.0192 13.179C13.2927 14.369 11.9962 15.2277 10.9949 14.6447L8.02144 12.9137C8.01564 12.9103 8.00829 12.9081 7.99984 12.9081C7.99138 12.9081 7.98404 12.9103 7.97824 12.9137L5.00478 14.6447C4.00347 15.2276 2.70693 14.369 2.98049 13.179L3.74082 9.87148C3.74101 9.87066 3.74101 9.8702 3.741 9.86987C3.74098 9.86963 3.74095 9.86929 3.74085 9.86887C3.7408 9.8686 3.74071 9.8683 3.7406 9.86797C3.74009 9.8664 3.73875 9.86356 3.73482 9.86018L1.1368 7.62251C0.212784 6.82665 0.73352 5.36259 1.90842 5.25575L5.35179 4.94263C5.36992 4.94098 5.37782 4.93066 5.37943 4.92698L6.74722 1.81297ZM7.97316 2.34C7.97311 2.34006 7.97098 2.34236 7.96799 2.34918L6.60019 5.46318C6.39934 5.92045 5.96409 6.22579 5.47253 6.27049L2.02916 6.5836C2.01824 6.5846 2.01278 6.58662 2.01107 6.58733C2.00921 6.58809 2.00841 6.5887 2.00792 6.58909C2.00654 6.59023 2.00327 6.5938 2.00116 6.60018C2.00042 6.60242 2.00009 6.60417 1.99994 6.60539L1.99999 6.60544C2.00112 6.60676 2.00329 6.6091 2.00694 6.61224L4.60496 8.84992C4.98224 9.17487 5.15267 9.68118 5.04026 10.1702L4.27993 13.4777C4.27949 13.4796 4.27922 13.4812 4.27905 13.4823C4.28053 13.4843 4.28333 13.4873 4.28813 13.4907C4.29721 13.4972 4.30606 13.4996 4.31129 13.4999C4.31351 13.5001 4.31554 13.5 4.31791 13.4994C4.32009 13.4989 4.32538 13.4974 4.33396 13.4924L7.30741 11.7614C7.73481 11.5126 8.26487 11.5126 8.69226 11.7614L11.6657 13.4924C11.6743 13.4974 11.6796 13.4989 11.6818 13.4994C11.6841 13.5 11.6862 13.5001 11.6884 13.4999C11.6936 13.4996 11.7025 13.4972 11.7115 13.4907C11.7163 13.4873 11.7191 13.4843 11.7206 13.4823C11.7205 13.4812 11.7202 13.4796 11.7197 13.4777L10.9594 10.1702C10.847 9.68118 11.0174 9.17487 11.3947 8.84992L13.9927 6.61224C13.9964 6.6091 13.9986 6.60676 13.9997 6.60544L13.9997 6.60539C13.9996 6.60417 13.9993 6.60242 13.9985 6.60019C13.9964 6.5938 13.9931 6.59023 13.9918 6.58909C13.9915 6.58891 13.9912 6.58869 13.9908 6.58843C13.9903 6.58811 13.9896 6.58775 13.9886 6.58733C13.9869 6.58662 13.9814 6.5846 13.9705 6.5836L10.5271 6.27049C10.0356 6.22579 9.60033 5.92045 9.39948 5.46318L8.03169 2.34918C8.02875 2.34249 8.02664 2.34015 8.02652 2.34001L8.02651 2.34L8.0265 2.33999C8.0263 2.33977 8.02604 2.33947 8.02506 2.33887C8.02234 2.3372 8.01365 2.33333 7.99984 2.33333C7.98603 2.33333 7.97733 2.3372 7.97461 2.33887C7.97362 2.33947 7.97336 2.33978 7.97316 2.34ZM1.99857 6.60363C1.9986 6.60367 1.99861 6.60373 1.99864 6.60379L1.99857 6.60363ZM1.99857 6.60363L1.99848 6.6035C1.99848 6.60349 1.99849 6.60351 1.99852 6.60356C1.99853 6.60358 1.99856 6.6036 1.99857 6.60363Z"
              fill="white"
            />
          </svg>
          {{ is_favoured ? '已收藏' : '收藏' }}
        </div>
      </div>
    </div>
  </div>
  <div class="com-album-card" v-else>
    <div class="delete-album">
      <img src="https://imgheybox.max-c.com/oa/2022/04/11/204a62279f0ada8227d0207f08172b74.png" alt="" class="delete-icon" />
    </div>
    <p class="delete-desc">创建者已删除</p>
  </div>
</template>
<script>
import { CptMixin } from '../../../mixins/CptMixin';
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import { toggleFollowAlbumState } from '_api/bbs/post-article/index';
export default {
  mixins: [CptMixin],
  data() {
    return {
      is_loading: true,
      card_data: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const {
        data: {
          result: { infos },
          status,
        },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = infos.find((_) => _.list_id == this.dataInfo.id);
      if (!this.card_data) return;
      this.is_loading = false;
      // console.log('[game_album],', this.card_data);
    },
    openAlbum() {
      let url = `${window.$WEB_HOST}/account/game_album/album_detail?list_id=${this.card_data.list_id}`,
        protocol = {
          protocol_type: 'openWindow',
          full_screen: true,
          navigation_bar: {
            title: '游戏单',
            right_icon: {
              enabled: true,
              protocol: {
                protocol_type: 'share',
                title: '分享游戏单：' + this.card_data.title,
                share_url: url + '&is_share=1',
                act_id: 'smgl_621dd00dae448520f7cecf2d',
              },
            },
          },
          webview: {
            url: url,
          },
        };
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(protocol);
          break;
        }
        case 'post': {
          executeProtocol(protocol);
          break;
        }
      }
    },
    async onClickFavourBtn() {
      switch (this.articleInfo.source) {
        case 'share': {
          this.openAlbum();
          break;
        }
        case 'post': {
          if (this.lock) return;
          this.lock = true;
          const {
            data: { status },
          } = await toggleFollowAlbumState({
            list_id: this.card_data.list_id,
            favour_state: this.is_favoured ? 0 : 1,
          });
          if (status != 'ok') {
            this.$hb_toast.failed(this.is_favoured ? '取消收藏失败' : '收藏失败');
            return;
          }
          this.$hb_toast.success(this.is_favoured ? '取消收藏成功' : '收藏成功');
          this.card_data.favour_state = !this.card_data.favour_state;
          this.lock = false;
          break;
        }
      }
    },
  },
  computed: {
    is_favoured() {
      return !(this.card_data.is_owner || !this.card_data.favour_state);
    },
  },
};
</script>

<style lang="less">
.com-album-card {
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .game-img-album,
  .delete-album {
    display: flex;
    flex-wrap: wrap;
    width: 86px;
    height: 64px;
    padding: 2px;
    border-radius: 3px;
    background: rgba(218, 221, 224, 1);
  }
  .game-img-album {
    &.layout-1 {
      .game-img-item {
        width: 100%;
        height: 100%;
      }
    }
    &.layout-2 {
      .game-img-item {
        width: calc(50% - 1px);
        height: calc(50% - 1px);
        &:nth-of-type(2) {
          margin-left: 2px;
        }
      }
    }
    &.layout-3 {
      .game-img-item {
        width: calc(50% - 1px);
        height: 19px;
        &:nth-of-type(1) {
          width: 100%;
          height: 39px;
        }
        &:nth-of-type(2) {
          margin-top: 2px;
        }
        &:nth-of-type(3) {
          margin-left: 2px;
          margin-top: 2px;
        }
      }
      &.layout-4 {
        .game-img-item {
          width: calc(50% - 1px);
          height: calc(50% - 1px);
          &:nth-of-type(2) {
            margin-left: 2px;
          }
          &:nth-of-type(3) {
            margin-top: 2px;
          }
          &:nth-of-type(4) {
            margin: 2px 0 0 2px;
          }
        }
      }
    }
    .game-img-item {
      border-radius: 3px;
      object-fit: cover;
    }
  }
  .delete-album {
    justify-content: center;
    align-items: center;
    background: #f3f4f5;
    .delete-icon {
      height: 22px;
      width: 17px;
    }
  }
  .delete-desc {
    margin-left: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #8c9196;
  }
  .album-info {
    flex: 1;
    width: 0;
    margin-left: 9px;
    .line-1 {
      display: flex;
      align-items: center;
      height: 22px;
      .album-label {
        position: relative;
        width: 27px;
        height: 16px;
        border-radius: 2px;
        background: #14191e;
        &::before {
          content: '专辑';
          position: absolute;
          top: 50%;
          left: 50%;
          font-size: 18px;
          font-weight: 500;
          line-height: 18px;
          color: rgba(255, 255, 255, 1);
          transform: scale(0.5) translate(-100%, -100%);
          transform-origin: center center;
          white-space: nowrap;
        }
      }
      .album-name {
        flex: 1;
        width: 0;
        margin-left: 4px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(20, 25, 30, 1);
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .line-2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .game-num {
        font-size: 11px;
        line-height: 15px;
        color: rgba(140, 145, 150, 1);
      }
      .favour-btn {
        display: flex;
        align-items: center;
        padding: 4px 7px;
        border-radius: 3px;
        background: rgba(20, 25, 30, 1);
        font-size: 12px;
        line-height: 16px;
        color: rgba(255, 255, 255, 1);
        &.favoured {
          background: #f3f4f5;
          color: rgba(140, 145, 150, 1);
        }
        svg {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
